import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMovementRouting extends Layout {
    sourceEquipmentGroup: DataSource;
    tableMovementRouting: Table;
}
